import React from "react";
import "./Assajos.scss";
import { Link } from "react-router-dom";
import Months from "../Calendari/Mesos"

export default class Assajos extends React.Component<{}, {}> {
  render(): React.ReactNode {
    return (
      <div id="assajos">
        <h1>Assajos</h1>
        <section className="calendari">
          <p>Mira el calendari complert d'assajos, actuacions i actes!</p>
          <Link to="/calendari">Calendari</Link>
        </section>
        <section className="propersAssajos">
          <h2>Propers Assajos</h2>
          <p></p>
          <ul className="assajos">
            {
              new Array(6).fill(0).map((_, i) => {
                const month = Months[i];
                return (
                  <li className="assaig" key={i}>
                    <span>{i}</span>
                    <p>{Math.random() > 0.5 ? 'Dimarts' : 'Divendres'}</p>
                  </li>
                );
              })
            }
          </ul>
        </section>
        <p>Per ara, si voleu venir a assajar, podeu contactar amb nosaltres a través de les nostres xarxes socials.</p>
      </div>
    );
  }
}